import { FCX, ID } from "@datassential/platform-ui-lib";
import { Link } from "react-scroll";
import './SectionsNav.scss';
import { FOOD_PAGE_SCROLLBAR_ID } from "@pages/Food/Food";

const FoodSectionsNav: FCX<{
    word: string;
    data: Array<{
        id: ID;
        title: string;
    }>
}> = ({
    data,
    word
}) => {
    return (
        <div className="FoodSectionsNav appears-top del-1">
            <div
                className="FoodSectionsNav__title"
                data-testid="textFoodSectionsNavTitle"
            >
                Know The Trend:
                <b data-testid="textFoodSectionsNavTitleWord"> {word} </b>
            </div>
            <div
                className="FoodSectionsNav__items"
                data-testid="blockFoodSectionsNavItems"
            >
                {data.map(({ id, title }, index) => (
                    <Link
                        activeClass="is-active"
                        className="FoodSectionsNav__item"
                        to={id as string}
                        key={id}
                        spy={true}
                        smooth={true}
                        duration={600}
                        offset={-80}
                        containerId={FOOD_PAGE_SCROLLBAR_ID}
                        data-testid={`buttonFoodSectionsNavItem-${index}`}
                    >
                        {title}
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default FoodSectionsNav;